import {parseMarkdown, renderMarkdownNodes, trimLastTextNode} from '@/utils/helpers/markdown';
import {ReactElement, useState} from 'react';
import ActionText from '../../atoms/ActionText/ActionText';
import {CollapsibleProps, Props} from './typings';

const DEFAULT_CHAR_LIMIT = 382;

const CollapsibleTextActive = ({
  fullRenderedNodes,
  truncatedNodes,
  fontSize,
  elementKey,
}: CollapsibleProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (isExpanded) {
    return fullRenderedNodes;
  }

  return (
    <>
      {renderMarkdownNodes(truncatedNodes, elementKey)}…{' '}
      <ActionText onClick={() => setIsExpanded(true)} fontSize={fontSize}>
        read more
      </ActionText>
    </>
  );
};

const CollapsibleText = ({
  elementKey,
  children,
  maxCharacters = DEFAULT_CHAR_LIMIT,
  fontSize,
}: Props): ReactElement => {
  const {truncatedNodes, nodes} = parseMarkdown(children, {maxCharacters});

  // Render full markdown loads to JSX - Pass to CollapsibleTextActive to avoid doing it twice.
  const fullRenderedNodes = renderMarkdownNodes(nodes, elementKey);

  if (!truncatedNodes) {
    return fullRenderedNodes;
  }

  // Trim any trailing spaces on the last node
  const trimmedTruncatedNodes = trimLastTextNode(truncatedNodes);

  return (
    <CollapsibleTextActive
      truncatedNodes={trimmedTruncatedNodes}
      fullRenderedNodes={fullRenderedNodes}
      fontSize={fontSize}
      elementKey={elementKey}
    />
  );
};

export default CollapsibleText;
